var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',{staticClass:"document-list"},[_c('base-list',{attrs:{"userType":_vm.userType,"listItems":_vm.badges,"showAdd":false,"showDelete":_vm.showDelete,"backgroundColor":"#f2eae2"}}),(_vm.showDelete)?_c('badge-upload'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }